<script lang="ts">
  import Image from './Image.svelte'
</script>

<button
  class="selected-item border-orange-200 bg-[#fff7f0] text-orange-600 hover:border-orange-400"
  type="button"
  on:click
>
  <span class="mr-2"><slot /></span>
  <Image src="/share/img/trash.svg" alt="&times;" height="15" width="15" />
</button>
